// This is auto generated files. DO NOT EDIT DIRECTLY
import type { Exact, InputMaybe, Locales, Scalars, ArticlePageWhereInput, CareerPageWhereInput, PersonPageWhereInput, LocationPageWhereInput, PageBaseWhereInput, PageBaseOrderByInput } from './cms-types';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(endpoint: string, requestInit: RequestInit, query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint, {
      method: 'POST',
      ...requestInit,
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ArticleListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  mediatype?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  theme?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  author?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  where?: InputMaybe<ArticlePageWhereInput>;
}>;


export type ArticleListingQuery = { __typename?: 'Query', ArticlePage?: { __typename?: 'ArticlePageOutput', total?: number | null, items?: Array<{ __typename?: 'ArticlePage', Name?: string | null, Url?: string | null, Title?: string | null, PreviewTitle?: string | null, PreviewDescription?: string | null, ArticlePublishDate?: any | null, ReadTimeInMins?: number | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null, GuidValue?: string | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ArticleListingPage' } | { __typename: 'ArticlePage' } | { __typename: 'CareerListingPage' } | { __typename: 'CareerPage' } | { __typename: 'Content' } | { __typename: 'Country' } | { __typename: 'DAMImageAsset' } | { __typename: 'FormContainerBlock' } | { __typename: 'HomePage' } | { __typename: 'ImageFile' } | { __typename: 'LocationListingPage' } | { __typename: 'LocationPage' } | { __typename: 'NotFoundPage' } | { __typename: 'PageBase' } | { __typename: 'PdfFile' } | { __typename: 'PeopleListingPage' } | { __typename: 'PersonPage', Name?: string | null, Role?: string | null, PreviewDescription?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'CareerListingPage' } | { __typename?: 'CareerPage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | { __typename: 'SearchPage' } | { __typename: 'StandardPage' } | { __typename: 'VectorImageFile' } | null } | null } | null> | null, MediaTypeCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null } | null> | null, ThemeCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null } | null> | null, PreviewImage?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null, ProviderName?: string | null, Url?: string | null, WorkId?: number | null, Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'CareerListingPage' } | { __typename?: 'CareerPage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null, Language?: { __typename?: 'ContentLanguageModel', DisplayName?: string | null, Link?: string | null, Name?: string | null } | null } | null } | null> | null, facets?: { __typename?: 'ArticlePageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, MediaTypeCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, ThemeCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, Authors?: { __typename?: 'ContentAreaItemModelSearchFacet', ContentLink?: { __typename?: 'ContentModelReferenceSearchFacet', GuidValue?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null } | null };

export type ImageFragment = { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null };

type Author_ArticleListingPage_Fragment = { __typename: 'ArticleListingPage' };

type Author_ArticlePage_Fragment = { __typename: 'ArticlePage' };

type Author_CareerListingPage_Fragment = { __typename: 'CareerListingPage' };

type Author_CareerPage_Fragment = { __typename: 'CareerPage' };

type Author_Content_Fragment = { __typename: 'Content' };

type Author_Country_Fragment = { __typename: 'Country' };

type Author_DamImageAsset_Fragment = { __typename: 'DAMImageAsset' };

type Author_FormContainerBlock_Fragment = { __typename: 'FormContainerBlock' };

type Author_HomePage_Fragment = { __typename: 'HomePage' };

type Author_ImageFile_Fragment = { __typename: 'ImageFile' };

type Author_LocationListingPage_Fragment = { __typename: 'LocationListingPage' };

type Author_LocationPage_Fragment = { __typename: 'LocationPage' };

type Author_NotFoundPage_Fragment = { __typename: 'NotFoundPage' };

type Author_PageBase_Fragment = { __typename: 'PageBase' };

type Author_PdfFile_Fragment = { __typename: 'PdfFile' };

type Author_PeopleListingPage_Fragment = { __typename: 'PeopleListingPage' };

type Author_PersonPage_Fragment = { __typename: 'PersonPage', Name?: string | null, Role?: string | null, PreviewDescription?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'CareerListingPage' } | { __typename?: 'CareerPage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null };

type Author_SearchPage_Fragment = { __typename: 'SearchPage' };

type Author_StandardPage_Fragment = { __typename: 'StandardPage' };

type Author_VectorImageFile_Fragment = { __typename: 'VectorImageFile' };

export type AuthorFragment = Author_ArticleListingPage_Fragment | Author_ArticlePage_Fragment | Author_CareerListingPage_Fragment | Author_CareerPage_Fragment | Author_Content_Fragment | Author_Country_Fragment | Author_DamImageAsset_Fragment | Author_FormContainerBlock_Fragment | Author_HomePage_Fragment | Author_ImageFile_Fragment | Author_LocationListingPage_Fragment | Author_LocationPage_Fragment | Author_NotFoundPage_Fragment | Author_PageBase_Fragment | Author_PdfFile_Fragment | Author_PeopleListingPage_Fragment | Author_PersonPage_Fragment | Author_SearchPage_Fragment | Author_StandardPage_Fragment | Author_VectorImageFile_Fragment;

export type CareerListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  employmentType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  department?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  where?: InputMaybe<CareerPageWhereInput>;
}>;


export type CareerListingQuery = { __typename?: 'Query', CareerPage?: { __typename?: 'CareerPageOutput', total?: number | null, items?: Array<{ __typename?: 'CareerPage', Name?: string | null, Url?: string | null, PreviewTitle?: string | null, PreviewDescription?: string | null, JobDescription?: string | null, CareerPublishDate?: any | null, ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null, GuidValue?: string | null } | null, Location?: Array<{ __typename?: 'CategoryModel', Name?: string | null } | null> | null, EmploymentType?: Array<{ __typename?: 'CategoryModel', Name?: string | null } | null> | null, Department?: Array<{ __typename?: 'CategoryModel', Name?: string | null } | null> | null, PreviewImage?: { __typename?: 'ContentModelReference', Url?: string | null, Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'CareerListingPage' } | { __typename?: 'CareerPage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | null> | null, facets?: { __typename?: 'CareerPageFacet', Location?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null, EmploymentType?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null, Department?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null };

export type LocationListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationPageWhereInput>;
}>;


export type LocationListingQuery = { __typename?: 'Query', LocationPage?: { __typename?: 'LocationPageOutput', total?: number | null, items?: Array<{ __typename?: 'LocationPage', PreviewTitle?: string | null, Title?: string | null, PreviewDescription?: string | null, Address?: string | null, PhoneNumber?: string | null, EmailAddress?: string | null, Latitude?: string | null, Longitude?: string | null, Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'CareerListingPage' } | { __typename?: 'CareerPage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, RegionCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Name?: string | null, Description?: string | null } | null> | null } | null> | null, facets?: { __typename?: 'LocationPageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, RegionCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, Description?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null };

export type PeopleListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  where?: InputMaybe<PersonPageWhereInput>;
}>;


export type PeopleListingQuery = { __typename?: 'Query', PersonPage?: { __typename?: 'PersonPageOutput', total?: number | null, items?: Array<{ __typename?: 'PersonPage', PreviewTitle?: string | null, Name?: string | null, Url?: string | null, PreviewDescription?: string | null, Role?: string | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'CareerListingPage' } | { __typename?: 'CareerPage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null } | { __typename?: 'LocationListingPage' } | { __typename?: 'LocationPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | null> | null, facets?: { __typename?: 'PersonPageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, RegionCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null } | null } | null };

export type SearchBlockQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  contenttype?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  where?: InputMaybe<PageBaseWhereInput>;
  orderBy?: InputMaybe<PageBaseOrderByInput>;
}>;


export type SearchBlockQuery = { __typename?: 'Query', PageBase?: { __typename?: 'PageBaseOutput', total?: number | null, items?: Array<{ __typename?: 'PageBase', PreviewTitle?: string | null, Name?: string | null, Url?: string | null, ContentType?: Array<string | null> | null, PreviewDescription?: string | null, FileSize?: string | null, _score?: number | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null> | null, facets?: { __typename?: 'PageBaseFacet', ContentType?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null };

export type CategoryFacetFragment = { __typename?: 'CategoryModelFacet', Description?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null };

export type CountryFragment = { __typename?: 'Country', Name?: string | null, PlaceId?: string | null };

export const ImageFragmentDoc = `
    fragment Image on ImageFile {
  Name
  Url
  Title
  Width
  Height
}
    `;
export const AuthorFragmentDoc = `
    fragment Author on IContent {
  __typename
  ... on PersonPage {
    Name
    Role
    PreviewDescription
    HeadshotImage {
      Expanded {
        ...Image
      }
    }
  }
}
    `;
export const CategoryFacetFragmentDoc = `
    fragment CategoryFacet on CategoryModelFacet {
  Description(filters: $category) {
    name
    count
  }
}
    `;
export const CountryFragmentDoc = `
    fragment Country on Country {
  Name
  PlaceId
}
    `;
export const ArticleListingDocument = `
    query ArticleListing($locale: [Locales!] = en_AU, $limit: Int = 50, $skip: Int = 0, $mediatype: [String!] = [], $theme: [String!] = [], $author: [String!] = [], $where: ArticlePageWhereInput) {
  ArticlePage(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: {ArticlePublishDate: DESC}
  ) {
    items {
      Name
      Url
      ContentLink {
        Url
        GuidValue
      }
      Title
      PreviewTitle
      PreviewDescription
      Authors {
        ContentLink {
          Expanded {
            ...Author
          }
        }
      }
      ArticlePublishDate
      ReadTimeInMins
      MediaTypeCategories {
        Id
        Description
      }
      ThemeCategories {
        Id
        Description
      }
      _fulltext
      PreviewImage {
        Expanded {
          ...Image
        }
        GuidValue
        Id
        Language {
          DisplayName
          Link
          Name
        }
        ProviderName
        Url
        WorkId
      }
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      MediaTypeCategories {
        Name(filters: $mediatype) {
          name
        }
      }
      ThemeCategories {
        Name(filters: $theme) {
          name
        }
      }
      Authors {
        ContentLink {
          GuidValue(filters: $author) {
            name
            count
          }
        }
      }
    }
  }
}
    ${AuthorFragmentDoc}
${ImageFragmentDoc}`;
export const useArticleListingQuery = <
      TData = ArticleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: ArticleListingQueryVariables,
      options?: UseQueryOptions<ArticleListingQuery, TError, TData>
    ) =>
    useQuery<ArticleListingQuery, TError, TData>(
      variables === undefined ? ['ArticleListing'] : ['ArticleListing', variables],
      fetcher<ArticleListingQuery, ArticleListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, ArticleListingDocument, variables),
      options
    );
export const CareerListingDocument = `
    query CareerListing($locale: [Locales!] = en_AU, $limit: Int = 50, $skip: Int = 0, $location: [String!] = [], $employmentType: [String!] = [], $department: [String!] = [], $where: CareerPageWhereInput) {
  CareerPage(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: {CareerPublishDate: DESC}
  ) {
    items {
      Name
      Url
      ContentLink {
        Url
        GuidValue
      }
      PreviewTitle
      PreviewDescription
      JobDescription
      CareerPublishDate
      Location {
        Name
      }
      EmploymentType {
        Name
      }
      Department {
        Name
      }
      PreviewImage {
        Expanded {
          ...Image
        }
        Url
      }
    }
    total
    facets {
      Location {
        Name(filters: $location) {
          name
          count
        }
      }
      EmploymentType {
        Name(filters: $employmentType) {
          name
          count
        }
      }
      Department {
        Name(filters: $department) {
          name
          count
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const useCareerListingQuery = <
      TData = CareerListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: CareerListingQueryVariables,
      options?: UseQueryOptions<CareerListingQuery, TError, TData>
    ) =>
    useQuery<CareerListingQuery, TError, TData>(
      variables === undefined ? ['CareerListing'] : ['CareerListing', variables],
      fetcher<CareerListingQuery, CareerListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CareerListingDocument, variables),
      options
    );
export const LocationListingDocument = `
    query LocationListing($locale: [Locales!] = en_AU, $limit: Int = 100, $skip: Int = 0, $where: LocationPageWhereInput) {
  LocationPage(locale: $locale, skip: $skip, limit: $limit, where: $where) {
    items {
      ContentLink {
        Id
        Url
      }
      PreviewTitle
      Title
      PreviewDescription
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      RegionCategories {
        Id
        Name
        Description
      }
      Address
      PhoneNumber
      EmailAddress
      Latitude
      Longitude
      Url
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      RegionCategories {
        Name {
          name
          count
        }
        Description {
          name
          count
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const useLocationListingQuery = <
      TData = LocationListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: LocationListingQueryVariables,
      options?: UseQueryOptions<LocationListingQuery, TError, TData>
    ) =>
    useQuery<LocationListingQuery, TError, TData>(
      variables === undefined ? ['LocationListing'] : ['LocationListing', variables],
      fetcher<LocationListingQuery, LocationListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, LocationListingDocument, variables),
      options
    );
export const PeopleListingDocument = `
    query PeopleListing($locale: [Locales!] = en_AU, $limit: Int = 50, $skip: Int = 0, $region: [String!] = [], $where: PersonPageWhereInput) {
  PersonPage(locale: $locale, skip: $skip, limit: $limit, where: $where) {
    items {
      ContentLink {
        GuidValue
        Url
      }
      PreviewTitle
      Name
      Url
      PreviewDescription
      Role
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      _fulltext
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      RegionCategories {
        Name(filters: $region) {
          name
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const usePeopleListingQuery = <
      TData = PeopleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: PeopleListingQueryVariables,
      options?: UseQueryOptions<PeopleListingQuery, TError, TData>
    ) =>
    useQuery<PeopleListingQuery, TError, TData>(
      variables === undefined ? ['PeopleListing'] : ['PeopleListing', variables],
      fetcher<PeopleListingQuery, PeopleListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, PeopleListingDocument, variables),
      options
    );
export const SearchBlockDocument = `
    query SearchBlock($locale: [Locales!] = en_AU, $limit: Int = 50, $skip: Int = 0, $contenttype: [String!] = [], $where: PageBaseWhereInput, $orderBy: PageBaseOrderByInput) {
  PageBase(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: $orderBy
  ) {
    items {
      PreviewTitle
      Name
      Url
      ContentType
      ContentLink {
        GuidValue
        Url
      }
      PreviewDescription
      PreviewImage {
        Url
      }
      FileSize
      _score
      _fulltext
    }
    facets {
      ContentType(filters: $contenttype, limit: 20) {
        name
        count
      }
    }
    total(all: true)
  }
}
    `;
export const useSearchBlockQuery = <
      TData = SearchBlockQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: SearchBlockQueryVariables,
      options?: UseQueryOptions<SearchBlockQuery, TError, TData>
    ) =>
    useQuery<SearchBlockQuery, TError, TData>(
      variables === undefined ? ['SearchBlock'] : ['SearchBlock', variables],
      fetcher<SearchBlockQuery, SearchBlockQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, SearchBlockDocument, variables),
      options
    );